<!--suppress JSUnresolvedVariable -->
<template>
  <div class="my-4 mx-1">
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/admin/dashboard' }"
          >管理中心
        </el-breadcrumb-item>
        <el-breadcrumb-item>基础配置</el-breadcrumb-item>
        <el-breadcrumb-item
          ><span class="text-primary">栏目管理</span></el-breadcrumb-item
        >
      </el-breadcrumb>
    </el-row>
    <el-card class="my-4 mx-1">
      <el-table
        ref="multipleTable"
        :data="navigationList"
        tooltip-effect="dark"
        style="width: 100%;min-height: 500px"
        stripe
        v-loading="loading"
        element-loading-text="拼命加载中"
      >
        <el-table-column
          prop="navId"
          label="栏目ID"
          sortable
          align="center"
          width="120"
        >
        </el-table-column>
        <el-table-column prop="navName" label="栏目名称" align="center">
        </el-table-column>
        <el-table-column prop="subTitle" label="栏目副标题" align="center">
        </el-table-column>
        <el-table-column prop="navOrder" label="导航顺序" align="center">
        </el-table-column>
        <el-table-column label="栏目状态" sortable align="center" width="138">
          <template slot-scope="scope">
            <el-switch
              :disabled="
                !adminPermissions.includes('/navigation/admin/updateNavigation')
              "
              v-model="scope.row.navStatus"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="激活"
              inactive-text="禁用"
              @change="value => navigationStatusChange(value, scope.row.navId)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button
              @click="editNavigation(scope.row.navId)"
              type="primary"
              plain
              size="small"
              icon="el-icon-edit"
              :disabled="
                !adminPermissions.includes('/navigation/admin/updateNavigation')
              "
              >编辑
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<!--suppress JSUnusedGlobalSymbols -->
<script>
export default {
  name: "NavigationInfo",
  data() {
    return {
      navigationList: [],
      adminPermissions: this.$store.state.adminPermissions,
      loading: false
    };
  },
  mounted() {
    this.getNavigationList();
  },
  methods: {
    getNavigationList() {
      this.loading = true;
      this.axios.get("/navigation/admin/getNavigationList").then(resp => {
        if (resp && resp.data.code === 10000 && resp.data.success) {
          this.navigationList = resp.data.data;
          this.loading = false;
        }
      });
    },
    editNavigation(navId) {
      this.$router
        .push({ name: "EditNavigation", params: { navId: navId } })
        .catch();
    },
    navigationStatusChange(value, navId) {
      this.axios
        .post("/navigation/admin/updateNavigation", {
          navId: navId,
          navStatus: value
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            if (value) {
              this.$notify({
                title: "操作成功",
                message: "栏目已启用！",
                type: "success"
              });
            } else {
              this.$notify({
                title: "操作成功",
                message: "栏目已禁用！",
                type: "success"
              });
            }
          }
        });
    }
  }
};
</script>

<style scoped></style>
